import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React, { useEffect, useState, useRef } from 'react';
import mitt from 'mitt';
import Box from '../Box';
import Icon from '../Icon';
import StackView from '../StackView';
import Text from '../Text';
import VariantProvider from '../VariantProvider';
import { useThemeValue } from '../system';
var iconPaths = {
  fill: 'radio-0',
  checked: 'radio-1'
};
var radioEmitter = mitt();

function Radio(_ref) {
  var checked = _ref.checked,
      css = _ref.css,
      disabled = _ref.disabled,
      id = _ref.id,
      label = _ref.label,
      name = _ref.name,
      _onBlur = _ref.onBlur,
      _onChange = _ref.onChange,
      _onFocus = _ref.onFocus,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'xs' : _ref$size,
      value = _ref.value,
      restProps = _objectWithoutPropertiesLoose(_ref, ["checked", "css", "disabled", "id", "label", "name", "onBlur", "onChange", "onFocus", "size", "value"]);

  var radioTheme = useThemeValue('radio');
  var inputRef = useRef();

  var _useState = useState(false),
      localChecked = _useState[0],
      setLocalChecked = _useState[1];

  var _useState2 = useState(false),
      focus = _useState2[0],
      setFocus = _useState2[1]; // Because radio components are grouped by the name prop we use an event emitter
  // as a way to toggle the state between each one


  useEffect(function () {
    function handleChange(target) {
      setLocalChecked(target === inputRef.current);
    }

    radioEmitter.on(name, handleChange);
    return function () {
      radioEmitter.off(name, handleChange);
    };
  }, []);
  return /*#__PURE__*/React.createElement(VariantProvider, {
    checked: checked === undefined ? localChecked : checked,
    focus: focus
  }, /*#__PURE__*/React.createElement(StackView, _extends({
    as: label ? 'label' : 'span',
    inline: true,
    axis: "horizontal",
    alignment: "center",
    shrink: 0,
    opacity: disabled ? 0.5 : undefined,
    cursor: disabled ? 'not-allowed' : undefined,
    position: "relative"
  }, restProps), /*#__PURE__*/React.createElement(Box, {
    innerRef: inputRef,
    as: "input",
    type: "radio",
    id: id,
    name: name,
    checked: checked,
    value: value,
    disabled: disabled,
    onChange: function onChange(event) {
      radioEmitter.emit(name, event.target);
      _onChange && _onChange(event);
    },
    onFocus: function onFocus(event) {
      setFocus(true);
      _onFocus && _onFocus(event);
    },
    onBlur: function onBlur(event) {
      setFocus(false);
      _onBlur && _onBlur(event);
    },
    position: "absolute",
    top: 0,
    left: 0,
    zIndex: 0,
    opacity: 0
  }), /*#__PURE__*/React.createElement(Icon, {
    className: "ui-kit-Radio-Icon",
    size: size
  }, /*#__PURE__*/React.createElement(Icon.Path, {
    name: iconPaths.fill,
    fill: radioTheme.fill,
    stroke: radioTheme.stroke,
    transform: "scale(1)",
    transformOrigin: "center center",
    transition: "all 180ms ease-out",
    variants: {
      hover: {
        transform: 'scale(1.125)'
      },
      focus: {
        transform: 'scale(1.125)',
        stroke: radioTheme.focusStroke
      },
      active: {
        transform: 'scale(1)'
      },
      checked: {
        fill: radioTheme.checkedFill,
        stroke: radioTheme.checkedStroke
      }
    }
  }), /*#__PURE__*/React.createElement(Icon.Path, {
    name: iconPaths.checked,
    fill: "#fff",
    transform: "scale(0)",
    transformOrigin: "center center",
    transition: "all 180ms ease-out",
    variants: {
      checked: {
        visibility: 'visible',
        transform: 'scale(1)',
        transition: 'all 120ms ease-out'
      }
    }
  })), label && /*#__PURE__*/React.createElement(Text, {
    fontSize: 4,
    lineHeight: 2.5,
    marginLeft: 0.5
  }, label)));
}

export default Radio;